import * as React from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import {Home, Login} from "../screens";
import bgNoise from "../assets/bg-noise.png";
import {PanelNavigator} from "./panel-navigator";
import {Submit} from "../screens/submit/submit-screen";
import {SubmitMessage} from "../screens/submit-message/submit-message-screen";
import FirebaseAuthContext, {AuthContext} from "../firebaseAuthContext";
import {useContext, useEffect} from "react";
import {useStores} from "../models";
import {observer} from "mobx-react-lite";
import { ProjectSetup } from "../screens/project-setup/project-setup";

interface RequireAuthProps {
    children: JSX.Element,
    redirectTo: string
}

function RequireAuth({children, redirectTo}: RequireAuthProps): JSX.Element {
    const authValue=useContext(AuthContext)
    if(authValue.userDataPresent) {
        if(authValue.user !== null) {
            console.log("authenticated")
            return children
        } else {
            console.log("not-authenticated")
            return  <Navigate to={redirectTo}/>
        }
    } else {
        return <></>
    }
}

export const AppNavigator = observer(function AppNavigator() {

    const {businessStore, authStore, projectStore} = useStores();

    const loadData = async () => {
        await authStore.loadStaff();
        businessStore.loadBusiness();
        projectStore.loadProjects();
    }

    useEffect(()=>{
        loadData()
    },[])

    return (
        <div className="AppNavigator" style={{
            flexGrow: 1,
            backgroundImage: `url(${bgNoise})`
        }}>
            <FirebaseAuthContext>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/submit" element={<Submit/>}/>
                    <Route path="/submit-message" element={<SubmitMessage/>}/>
                    <Route path="/panel/*" element={
                        <RequireAuth redirectTo="/login">
                            <PanelNavigator/>
                        </RequireAuth>
                    }/>
                    <Route path="/project-setup" element={
                        <RequireAuth redirectTo="/login">
                            <ProjectSetup/>
                        </RequireAuth>
                    }/>
                </Routes>
            </FirebaseAuthContext>
        </div>
    );
})
